import React, { useEffect, useRef } from "react";
import card from "Assets/images/card.jpg";
import { Dialog, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { useOrderAttributeProvider } from "../context/order";
import { useState } from "react";
import { styled } from "@mui/material";
import GreetingCardEditor from "Components/WYSIWIGEditor/GreetingCardEditor";
import TextArea from "Components/FormControl/TextArea/TextArea";
import { htmlToPlainText } from "../utility/util";

const useStyles = styled({
  card: {
    "& textarea": {
      textAlign: "center",
    },
  },
});

const GreetingCard = () => {
  const classes = useStyles();
  const formik = useFormikContext();
  const { active, orderDetail } = useOrderAttributeProvider();
  const [show, setShow] = useState(false);
  const [initialValue, setInitialValue] = useState(
    orderDetail?.order_recipients[active]?.greetings_on_card
  );
  // const [length, setLength] = React.useState(0);
  // const editorRef = useRef(null);
  // const [message, setMessage] = useState(
  //   orderDetail?.order_recipients[active]?.greetings_on_card
  // );

  const [iframe, setIframe] = useState("");

  useEffect(() => {
    if (
      formik.values.recipients[active].video_url &&
      formik.values.recipients[active].video_url.includes("vimeo")
    ) {
      fetch(
        `https://vimeo.com/api/oembed.json?url=${formik.values.recipients[active].video_url}`
      )
        .then((d) => d.json())
        .then((r) => {
          setIframe(r.html);
        });
    }
  }, [active, formik.values.recipients]);

  // const handleInit = (evt, editor) => {
  //   editorRef.current = editor;
  //   setLength(editor.getContent({ format: "text" }).length);
  // };


  // useEffect(() => {
  //   setInitialValue(orderDetail?.order_recipients[active]?.greetings_on_card);
  //   setMessage(orderDetail?.order_recipients[active]?.greetings_on_card);
  // }, [orderDetail?.order_recipients[active]?.greetings_on_card]);

  //calculate length of the text for current recipient
  const length = htmlToPlainText(formik.values?.recipients[active]?.greetings_on_card)?.length;
  const greetingCardMessage = formik.values?.recipients[active]?.greetings_on_card || "";

  return (
    <div className="my-5">
      {formik.values.recipients[active].video_url && (
        <a
          className="d-inline-block mb-3"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            setShow(true);
          }}
        >
          {"Show video message"}
        </a>
      )}
      <Dialog open={show} onClick={() => setShow(false)}>
        {formik.values.recipients[active].video_url && !iframe && (
          <video
            controls
            src={formik.values.recipients[active].video_url}
          ></video>
        )}
        {iframe && <div dangerouslySetInnerHTML={{ __html: iframe }}></div>}
      </Dialog>
      <div
        className={classes.card}
        style={{ height: 400, position: "relative", width: "max-content" }}
      >
        <img style={{ height: "100%" }} src={card} alt="Card" />
        <div
          style={{
            position: "absolute",
            top: "25%",
            overflowWrap: "break-word",
            height: "230px",
            width: "48%",
            textAlign: "center",
            left: "51.5%",
            transform: "translateX(-50%)",
            padding: "0 10px",
            // fontWeight: "normal",
          }}
        >
          {/* {formik.values.recipients[active].greetings_on_card  
            && <div dangerouslySetInnerHTML={{ __html: formik.values.recipients[active].greetings_on_card }}></div>
          } */}
          {formik.values?.recipients[active]?.greetings_on_card}
        </div>
        <span
          style={{
            fontWeight: "bold",
            position: "absolute",
            bottom: "17%",
            height: "50px",
            padding: "0 1rem",
            display: "inline-block",
            textAlign: "center",
            whiteSpace: "pre-line",
            wordBreak: "break-all",
            width: "48%",
            lineHeight: 1,
            left: "51.5%",
            transform: "translateX(-50%)",
          }}
        >
          {formik.values?.recipients[active]?.card_signature}
        </span>
        <p className="text-right my-1">
          {/* <span>{250 - length} / 250 Characters Left</span> */}
          <span>
            {250 - (greetingCardMessage?.length || 0)} / 250 Characters Left
          </span>
        </p>
        
        {/* <GreetingCardEditor
          key={initialValue}
          initialValue={initialValue}
          value={formik.values?.recipients[active]?.greetings_on_card}
          // onInit={handleInit}
          onEditorChange={(content, editor) => {
            const length = editor.getContent({ format: "text" }).length;
            if (length <= 250) {
              let recipients = [...formik.values?.recipients];
              recipients[active].greetings_on_card = content;
              formik.setValues((v) => {
                return {
                  ...v,
                  recipients,
                };
              });
            }
          }}
          charLimit={250}
          // label="Write your greeting message here..."
          placeholder="Write your greeting message here..."
        /> */}

        <TextArea
          label="Write your greeting message here..."
          inputStyle={{ textAlign: "left" }}
          value={formik.values?.recipients[active]?.greetings_on_card}
          onChange={(e) => {
            if (e.length <= 250) {
              let recipients = [...formik.values?.recipients];
              recipients[active].greetings_on_card = e;
              formik.setValues((v) => {
                return {
                  ...v,
                  recipients,
                };
              });
            }
          }}
        />

        <TextField
          value={formik.values?.recipients[active]?.card_signature}
          onChange={(e) => {
            if (e.target.value.length < 60) {
              let newString = e.target.value;
              // let newString = removeEmojiFromString(e.target.value);

              let recipients = [...formik.values?.recipients];
              recipients[active].card_signature = newString;
              formik.setValues((v) => {
                return {
                  ...v,
                  recipients,
                };
              });
            } else {
              return;
            }
          }}
          className="w-100"
          label="Card Signature"
          variant="standard"
        />
      </div>
    </div>
  );
};

export default GreetingCard;
